import { render, staticRenderFns } from "./about-dialog.vue?vue&type=template&id=cb6a2514&"
import script from "./about-dialog.vue?vue&type=script&lang=ts&"
export * from "./about-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports